import { styled } from '@linaria/react';

export const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin: 0 8px;
  height: 24px;
  padding: 6px 8px;
  background: #2c9e49;
  border-radius: 8px;
`;
